<template>
  <component
    :is="item.external ? 'a' : 'router-link'"
    :href="item.external ? item.path : null"
    :to="item.external ? null : item.path"
    :target="item.external ? '_blank' : null"
    class="layout-sidebar-item"
  >
    <k-icon
      class="icon"
      size="15"
      :icon="item.icon"
    />

    <span>{{ item.name }}</span>

    <k-icon
      v-if="arrow"
      class="arrow"
      size="10"
      icon="arrow-right"
    />
  </component>
</template>

<script>
import { KIcon } from 'kaledo-components'
export default {
  components: { KIcon },
  props: {
    item: {
      type: Object,
      required: true
    },
    arrow: Boolean
  }
}
</script>

<style lang="scss">
.layout-sidebar-item {
  display: block;
  text-align: left;
  width: 200px;
  margin: auto;
  position: relative;
  text-decoration: none;
  color: rgba(17.85, 30.6, 71.4, 1);
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  font-weight: 500;
  font-family: 'Ubuntu', sans-serif;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding-top: 18px;
  padding-bottom: 18px;
  cursor: pointer;

  & > .icon,
  & > .arrow {
    fill: rgba(17.85, 30.6, 71.4, .5);
  }

  & > .icon { margin-right: 17px; }

  & > .arrow {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/LayoutSidebarItem.vue